import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { createTheme, ThemeProvider as MuiThemeProvider, type Theme } from '@mui/material/styles';
const defaultTheme = createTheme();

// It is a good practice to hoist the <GlobalStyles /> to a static constant, to avoid rerendering. This will ensure that the <style> tag generated would not recalculate on each render.
// https://v5.mui.com/material-ui/customization/how-to-customize/#3-global-theme-overrides
const globalBaseLine = <GlobalStyles styles={() => ({
  body: {
    minHeight: '100svh',
    maxHeight: '100svh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  '#sentry-feedback': {
    '--inset': 'auto 0 0 auto',
    '--page-margin': '16px 16px 80px 4px',
    '--accent-background': '#48A1DB',
    '--button-border': '1.5px solid #48A1DB'
  }
})} />;
export function ThemeProvider(t0) {
  const $ = _c(4);
  const {
    children,
    theme
  } = t0;
  const t1 = theme || defaultTheme;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CssBaseline />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== children || $[2] !== t1) {
    t3 = <MuiThemeProvider theme={t1}>{t2}{globalBaseLine}{children}</MuiThemeProvider>;
    $[1] = children;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}